/**
 * Copyright 2022 (C) Blink - All Rights Reserved
 *
 * This source code is protected under international copyright law.  All rights
 * reserved and protected by the copyright holders.
 * All files are confidential and only available to authorized individuals with the
 * permission of the copyright holders. If you encounter any file and do not have
 * permission, please get in touch with the copyright holders and delete this file.
 */
import { handleCustomNoteFilling } from "pages/choices/pages/Preferences/usePreferences";
import { useEffect } from "react";

const DEFAULTS = {
  skipIf: () => false,
  onSkip: () => {},
  setCustomNote: () => {},
  setter: () => {},
};

const usePrefillPreferences = (preferences, handlers) => {
  const { skipIf, onSkip, setCustomNote, setter } = {
    ...DEFAULTS,
    ...handlers,
  };
  useEffect(() => {
    if (!preferences || !preferences.length) return;
    const options = preferences?.split(",");
    if (setCustomNote) {
      const customPref = handleCustomNoteFilling(preferences);
      if (customPref) setCustomNote(customPref);
    }

    options?.forEach((pref) => {
      if (pref === "" || !pref || pref.includes("undefined")) return;
      if (skipIf && skipIf(pref)) return onSkip(pref);
      if (pref.startsWith("other:") && setCustomNote) {
        return setter((prev) => {
          // in case it had other property
          if (prev.hasOwnProperty("other")) {
            return { ...prev, other: { state: "success", value: "other" } };
          }
          if (prev.hasOwnProperty("Other")) {
            return { ...prev, Other: { state: "success", value: "Other" } };
          }
          return prev;
        });
      }
      setter((prev) => {
        return { ...prev, [pref]: { state: "success", value: pref } };
      });
    });
  }, [preferences]);
};

export default usePrefillPreferences;
